<template>
	<div class="panel panel-info">
		<div class="panel-heading"><h4 class="panel-title"><i class="fa fa-book"></i>试卷预览</h4></div>
		<div class="panel-body">
			<div class="paper_main">
			    <div class="ks_left" style="width:100%">
			        <div class="test">
			            <div class="test_content">
			                <form>
								<div action="">
								    <div class="test_sj" style="text-align: center;">
										<h2 style="font-family: '宋体';">
										    <b>{{sjdata.paperMap.sjmc || ''}}</b>
										</h2>
								        <h1 style="font-family: '宋体';font-weight: bold;font-size: 22px;line-height: 30px;">
								            {{sjdata.paperMap.kcdm}}-{{sjdata.paperMap.kcmc}}-综合测验</h1>
								        <h1 style="font-family: '宋体';font-weight:normal;;font-size: 18px;line-height: 30px;">
								            (课程：{{sjdata.paperMap.kcdm}}-{{sjdata.paperMap.kcmc}})</h1>
								        <h2 style="font-family: '宋体';font-size: 15px;text-align: center;">考试形式：闭卷■、开卷□</h2>
								        <h2 style="font-family: '宋体';font-size: 15px;text-align: center;">
								            考试时间：{{sjdata.paperMap.kssc || ''}}分钟</h2>
								        <h2 style="font-family: '宋体';font-size: 15px;text-align: center;">
								            考生姓名：<span style="text-decoration: underline;margin-right: 10px;font-size: 15px;">&nbsp;&nbsp;</span>
								            准考证号：<span style="text-decoration: underline;margin-right: 10px;font-size: 15px;">&nbsp;&nbsp;</span>
								            身份证号：<span style="text-decoration: underline;margin-right: 10px;font-size: 15px;">&nbsp;&nbsp;</span>
								        </h2>
								        <table class="scoreTable" v-if="sjdata.paper && sjdata.paper.sections">
								            <tbody>
								            <tr>
								                <td style="width: 60px;">题序</td>
								                <td v-for="(section, index) in sjdata.paper.sections" :key="'tixu_'+index">
								                    {{sectionNumber[index+1]}}
								                </td>
								                <td>总分</td>
								            </tr>
								            <tr>
								                <td>得分</td>
								                <td v-for="(section, index) in sjdata.paper.sections" :key="'score_'+index">
								                </td>
								                <td></td>
								            </tr>
								            <tr>
								                <td>评卷人</td>
								                <td v-for="(section, index) in sjdata.paper.sections" :key="'teacher_'+index">
								                </td>
								                <td></td>
								            </tr>
								            </tbody>
								        </table>
								        <h2 style="font-family: '宋体';font-weight:normal;font-size: 15px;line-height: 25px;">
								            卷面总分:{{sjdata.paper.jmzf}}
								            及格分数 : {{sjdata.paper.jgf}}
								        </h2>
								    </div>
								</div>

			                    <!--题目模板-->
			                    <!--大题-->
			                    <div style="border: 1px solid #DDDDDD;;margin: 10px"
			                         v-for="(section,index) in this.sjdata.paper.sections" :key="'section_'+index">
			                        <!--大题名称-->
			                        <div class="ks_coon_bt">
			                            <p>
			                                {{sectionNumber[index+1]}}、{{section.remark}}（本大题共{{section.questions.length}}小题，每小题{{section.rscore}}分，共{{section.questions.length*section.rscore}}分）</p>
			                        </div>
			                        <!--小题区域-->
			                        <template v-for="(question,ques_index) in section.questions">

			                            <!--小题模板 单选题-->
			                            <div class="ks_coon_date" v-if="question.stlb=='SINGLECHOICE'"
			                                 :key="question.stlb.toLowerCase()+'_question_'+ques_index"
			                                 :id="question.stlb.toLowerCase()+'_question_'+ques_index">
			                                <!--小题题干-->
			                                <table>
			                                    <tbody>
			                                    <tr>
			                                        <td>
			                                            <h6>
			                                                <span>{{ques_index+1}}</span>
			                                            </h6>
			                                        </td>
			                                        <td>
			                                            <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                                        </td>
			                                    </tr>
			                                    </tbody>
			                                </table>
			                                <!--单选题选项-->
			                                <table class="optTbl">
			                                    <tbody>
			                                    <tr v-for="(option,qps_index) in question.options"
			                                        :key="question.stlb.toLowerCase()+'_option_'+qps_index">
			                                        <td class="td1" valign="bottom">
			                                            <label v-html="option.alisa+'.'" style="margin-left: 5px"></label>
			                                        </td>
			                                        <td valign="bottom">
			                                            <label v-html="option.text || ''"></label>
			                                        </td>
			                                    </tr>
			                                    </tbody>
			                                </table>
			                                <!--正确答案与解析-->
			                                <div class="div-key-container" style="padding-left:20px">
			                                    <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                                    <span style="color: #417ac1;" v-html="question.stda"></span>
			                                </div>
			                                <div class="div-key-container" style="padding-left: 20px">
			                                    <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
			                                    <span style="color: #2a8801;" v-html="question.stjx"></span>
			                                </div>
			                            </div>
			                            <!--结束-->

			                            <!--小题模板 多选题-->
			                            <div class="ks_coon_date" v-if="question.stlb=='MULTIPLECHOICE'"
			                                 :id="question.stlb.toLowerCase()+'_question_'+ques_index"
			                                 :key="question.stlb.toLowerCase()+'_question_'+ques_index">
			                                <!--小题题干-->
			                                <table>
			                                    <tbody>
			                                    <tr>
			                                        <td>
			                                            <h6>
			                                                <span>{{ques_index+1}}</span>
			                                            </h6>
			                                        </td>
			                                        <td>
			                                            <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                                        </td>
			                                    </tr>
			                                    </tbody>
			                                </table>
			                                <!--多选题选项-->
			                                <table class="optTbl">
			                                    <tbody>
			                                    <tr v-for="(option,qps_index) in question.options"
			                                        :key="question.stlb.toLowerCase()+'_option_'+qps_index">
			                                        <td class="td1" valign="bottom"><label v-html="option.alisa+'.'" style="margin-left: 5px"></label></td>
			                                        <td valign="bottom">
			                                            <label v-html="option.text || ''"></label>
			                                        </td>
			                                    </tr>
			                                    </tbody>
			                                </table>
			                                <!--正确答案与解析-->
			                                <div class="div-key-container" style="padding-left:20px">
			                                    <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                                    <span style="color: #417ac1;" v-html="question.stda"></span>
			                                </div>
			                                <div class="div-key-container" style="padding-left: 20px">
			                                    <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
												 <span style="color: #2a8801;" v-html="question.stjx"></span>
			                                </div>
			                            </div>
			                            <!--结束-->

			                            <!--小题模板 判断题-->
			                            <div class="ks_coon_date" v-if="question.stlb=='JUDGMENT'"
			                                 :key="question.stlb.toLowerCase()+'_question_'+ques_index"
			                                 :id="question.stlb.toLowerCase()+'_question_'+ques_index">
			                                <!--小题题干-->
			                                <table>
			                                    <tbody>
			                                    <tr>
			                                        <td>
			                                            <h6>
			                                                <span>{{ques_index+1}}</span>
			                                            </h6>
			                                        </td>
			                                        <td>
			                                            <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                                        </td>
			                                    </tr>
			                                    </tbody>
			                                </table>
			                                <!--正确答案与解析-->
			                                <div class="div-key-container" style="padding-left:20px">
			                                    <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                                    <span style="color: #417ac1;" v-html="question.stda ? (question.stda =='Y'?'正确':'错误') : ''"></span>
			                                </div>
			                                <div class="div-key-container" style="padding-left: 20px">
			                                    <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
												 <span style="color: #2a8801;" v-html="question.stjx"></span>
			                                </div>
			                            </div>
			                            <!--结束-->

			                            <!--小题模板 填空题-->
			                            <div class="ks_coon_date" v-if="question.stlb=='BLANKFILL'"
			                                 :id="question.stlb.toLowerCase()+'_question_'+ques_index"
			                                 :key="question.stlb.toLowerCase()+'_question_'+ques_index">
			                                <!--小题题干-->
			                                <table>
			                                    <tbody>
			                                    <tr>
			                                        <td>
			                                            <h6>
			                                                <span>{{ques_index+1}}</span>
			                                            </h6>
			                                        </td>
			                                        <td>
			                                            <p class="ks_coon_dates" v-html="question.displaySttg || ''"></p>
			                                        </td>
			                                    </tr>
			                                    </tbody>
			                                </table>
			                                <!--正确答案与解析-->
			                                <div class="div-key-container" style="padding-left:20px">
			                                    <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                                    <span style="color: #417ac1;" v-html="question.stda "></span>
			                                </div>
			                                <div class="div-key-container" style="padding-left: 20px">
			                                    <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
												 <span style="color: #2a8801;" v-html="question.stjx"></span>
			                                </div>
			                            </div>
			                            <!--结束-->

			                            <!--小题模板 问答题-->
			                            <div class="ks_coon_date"
			                                 v-if="question.stlb=='ESSAY' || question.stlb=='MCJST' || question.stlb=='LST' || question.stlb=='JDT'"
			                                 :id="question.stlb.toLowerCase()+'_question_'+ques_index"
			                                 :key="question.stlb.toLowerCase()+'_question_'+ques_index">
			                                <!--小题题干-->
			                                <table>
			                                    <tbody>
			                                    <tr>
			                                        <td>
			                                            <h6>
			                                                <span>{{ques_index+1}}</span>
			                                            </h6>

			                                        </td>
			                                        <td>
			                                            <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                                        </td>
			                                    </tr>
			                                    </tbody>
			                                </table>
			                                <!--正确答案与解析-->
			                                <div class="div-key-container" style="padding-left:20px">
			                                    <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                                    <span style="color: #417ac1;" v-html="question.stda"></span>
			                                </div>
			                                <div class="div-key-container" style="padding-left: 20px">
			                                    <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
												 <span style="color: #2a8801;" v-html="question.stjx"></span>
			                                </div>
			                            </div>
			                            <!--结束-->

			                         	<!--套题-->
			                            <div class="ks_coon_date" v-if="question.stlb=='TT'"
			                                 :key="question.stlb.toLowerCase()+'_question_'+ques_index"
			                                 :id="question.stlb.toLowerCase()+'_question_'+ques_index">
			                                 <table>
			                                    <tbody>
			                                    <tr>
			                                        <td>
			                                            <h6>
			                                                <span>{{ques_index+1}}</span>
			                                            </h6>
			                                        </td>
			                                        <td>
			                                            <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                                        </td>
			                                    </tr>
			                                    </tbody>
			                                 </table>
			                                 <template v-for="(question,ques_index) in question.children">
				                                <!--小题模板 单选题-->
				                                <div class="ks_coon_date" v-if="question.stlb=='SINGLECHOICE'"
				                                     :key="question.stlb.toLowerCase()+'_question_'+ques_index"
				                                     :id="question.stlb.toLowerCase()+'_question_'+ques_index">
				                                    <!--小题题干-->
				                                    <table>
				                                        <tbody>
				                                        <tr>
				                                            <td>
				                                                <h6>
				                                                    <p class="ys">({{ques_index+1}})</p>
				                                                </h6>
				                                            </td>
				                                            <td>
				                                                <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
				                                            </td>
				                                        </tr>
				                                        </tbody>
				                                    </table>
				                                    <!--单选题选项-->
				                                    <table class="optTbl">
				                                        <tbody>
				                                        <tr v-for="(option,qps_index) in question.options"
				                                            :key="question.stlb.toLowerCase()+'_option_'+qps_index">
				                                            <td class="td1" valign="bottom">
				                                                <label v-html="option.alisa+'.'" style="margin-left: 5px"></label>
				                                            </td>
				                                            <td valign="bottom">
				                                                <label v-html="option.text || ''"></label>
				                                            </td>
				                                        </tr>
				                                        </tbody>
				                                    </table>
				                                    <!--正确答案与解析-->
				                                    <div class="div-key-container" style="padding-left:20px">
				                                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
				                                        <span style="color: #417ac1;" v-html="question.stda"></span>
				                                    </div>
				                                    <div class="div-key-container" style="padding-left: 20px">
				                                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
				                                        <span style="color: #2a8801;" v-html="question.stjx"></span>
				                                    </div>
				                                </div>
				                                <!--结束-->

				                                <!--小题模板 多选题-->
				                                <div class="ks_coon_date" v-if="question.stlb=='MULTIPLECHOICE'"
				                                     :id="question.stlb.toLowerCase()+'_question_'+ques_index"
				                                     :key="question.stlb.toLowerCase()+'_question_'+ques_index">
				                                    <!--小题题干-->
				                                    <table>
				                                        <tbody>
				                                        <tr>
				                                            <td>
				                                                <h6>
				                                                    <p class="ys">({{ques_index+1}})</p>
				                                                </h6>
				                                            </td>
				                                            <td>
				                                                <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
				                                            </td>
				                                        </tr>
				                                        </tbody>
				                                    </table>
				                                    <!--多选题选项-->
				                                    <table class="optTbl">
				                                        <tbody>
				                                        <tr v-for="(option,qps_index) in question.options"
				                                            :key="question.stlb.toLowerCase()+'_option_'+qps_index">
				                                            <td class="td1" valign="bottom"><label v-html="option.alisa+'.'" style="margin-left: 5px"></label></td>
				                                            <td valign="bottom">
				                                                <label v-html="option.text || ''"></label>
				                                            </td>
				                                        </tr>
				                                        </tbody>
				                                    </table>
				                                    <!--正确答案与解析-->
				                                    <div class="div-key-container" style="padding-left:20px">
				                                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
				                                        <span style="color: #417ac1;" v-html="question.stda"></span>
				                                    </div>
				                                    <div class="div-key-container" style="padding-left: 20px">
				                                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
														 <span style="color: #2a8801;" v-html="question.stjx"></span>
				                                    </div>
				                                </div>
				                                <!--结束-->

				                                <!--小题模板 判断题-->
				                                <div class="ks_coon_date" v-if="question.stlb=='JUDGMENT'"
				                                     :key="question.stlb.toLowerCase()+'_question_'+ques_index"
				                                     :id="question.stlb.toLowerCase()+'_question_'+ques_index">
				                                    <!--小题题干-->
				                                    <table>
				                                        <tbody>
				                                        <tr>
				                                            <td>
				                                                <h6>
				                                                    <p class="ys">({{ques_index+1}})</p>
				                                                </h6>
				                                            </td>
				                                            <td>
				                                                <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
				                                            </td>
				                                        </tr>
				                                        </tbody>
				                                    </table>
				                                    <!--正确答案与解析-->
				                                    <div class="div-key-container" style="padding-left:20px">
				                                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
				                                        <span style="color: #417ac1;" v-html="question.stda ? (question.stda =='Y'?'正确':'错误') : ''"></span>
				                                    </div>
				                                    <div class="div-key-container" style="padding-left: 20px">
				                                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
														 <span style="color: #2a8801;" v-html="question.stjx"></span>
				                                    </div>
				                                </div>
				                                <!--结束-->

				                                <!--小题模板 填空题-->
				                                <div class="ks_coon_date" v-if="question.stlb=='BLANKFILL'"
				                                     :id="question.stlb.toLowerCase()+'_question_'+ques_index"
				                                     :key="question.stlb.toLowerCase()+'_question_'+ques_index">
				                                    <!--小题题干-->
				                                    <table>
				                                        <tbody>
				                                        <tr>
				                                            <td>
				                                                <h6>
				                                                    <p class="ys">({{ques_index+1}})</p>
				                                                </h6>
				                                            </td>
				                                            <td>
				                                                <p class="ks_coon_dates" v-html="question.displaySttg || ''"></p>
				                                            </td>
				                                        </tr>
				                                        </tbody>
				                                    </table>
				                                    <!--正确答案与解析-->
				                                    <div class="div-key-container" style="padding-left:20px">
				                                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
				                                        <span style="color: #417ac1;" v-html="question.stda "></span>
				                                    </div>
				                                    <div class="div-key-container" style="padding-left: 20px">
				                                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
														 <span style="color: #2a8801;" v-html="question.stjx"></span>
				                                    </div>
				                                </div>
				                                <!--结束-->

				                                <!--小题模板 问答题-->
				                                <div class="ks_coon_date"
				                                     v-if="question.stlb=='ESSAY' || question.stlb=='MCJST' || question.stlb=='LST' || question.stlb=='JDT'"
				                                     :id="question.stlb.toLowerCase()+'_question_'+ques_index"
				                                     :key="question.stlb.toLowerCase()+'_question_'+ques_index">
				                                    <!--小题题干-->
				                                    <table>
				                                        <tbody>
				                                        <tr>
				                                            <td>
				                                                <h6>
				                                                    <p class="ys">({{ques_index+1}})</p>
				                                                </h6>

				                                            </td>
				                                            <td>
				                                                <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
				                                            </td>
				                                        </tr>
				                                        </tbody>
				                                    </table>
				                                    <!--正确答案与解析-->
				                                    <div class="div-key-container" style="padding-left:20px">
				                                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
				                                        <span style="color: #417ac1;" v-html="question.stda"></span>
				                                    </div>
				                                    <div class="div-key-container" style="padding-left: 20px">
				                                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
														 <span style="color: #2a8801;" v-html="question.stjx"></span>
				                                    </div>
				                                </div>
				                                <!--结束-->
				                            </template>
			                            </div>
			                        </template>
			                    </div>
			                </form>
			            </div>
			        </div>
			    </div>
			</div>
		</div>
	</div>
</template>
<script>

    /**
     * 平时作业-详情  -  预览试卷
     */

    import tableMixin from '@/mixins/table.js';
    export default {
        mixins: [tableMixin],
        name: "ExamPaperView",
        data: function () {
            return {
                paperId:this.$route.query.id,
                sjdata: {
                    paperMap: {},
                    paper: {}
                },
                sectionNumber: {
                    '1': '一',
                    '2': '二',
                    '3': '三',
                    '4': '四',
                    '5': '五',
                    '6': '六',
                    '7': '七',
                    '8': '八',
                    '9': '九',
                    '10': '十',
                    '11': '十一',
                    '12': '十二',
                    '13': '十三',
                    '14': '十四',
                    '15': '十五',
                    '16': '十六',
                    '17': '十七',
                    '18': '十八',
                    '19': '十九',
                    '20': '二十'
                }
            }
        },
        created: function () {
            this.$store.commit('setBreadcrumb', [{name: '职业培训'}, {name: '在线培训'}, {name: '试卷管理'}, {name: '平时作业作业预览'}]);
			this.$store.commit('setShowReturnBackBtn',true);
            this.getPaper();
        },
        computed: {
            sjflmc: function () {
                let obj = {
                    'ZHCY': "综合测验",
                    'PSZY': '平时作业'
                }
                return obj[this.sjdata.paperMap.sjfl] || '';
            }
        },
        methods: {
			getPaper:function(){
				this.$http.post('/htgl/biz/zypx/sj/zhcy/xq',{sjId:this.paperId}).then(res=>{
					if (res.data) {
						this.sjdata = res.data;
						this.sjdata.paperMap = this.sjdata.paperMap || {};
						this.sjdata.paper = this.sjdata.paper || {};
						this.sjdata.paper.sections = this.sjdata.paper.sections || [];
						this.sjdata.paper.sections.forEach(x => {
						    x.questions = x.questions || [];
						    x.questions.forEach(item => {
								if(item.stjx){
									item.stjx = item.stjx.replace('<p>','').replace('</p>','')
								}
						        if (item.stlb == 'BLANKFILL') {
						            let regExp = /(\[BlankArea(\d+)\])+/g;
						            let blankInput = '_____';
						            let a = item.sttg.replace(regExp, blankInput);
						            item.displaySttg = a || item.sttg;
						        }else if(item.stlb == 'TT'){
	                            	item.children.forEach(item => {
			                            if (item.stlb == 'BLANKFILL') {
			                                let regExp = /(\[BlankArea(\d+)\])+/g;
								            let blankInput = '_____';
								            let a = item.sttg.replace(regExp, blankInput);
								            item.displaySttg = a || item.sttg;
			                            }
			                        });
	                            }
						    });
						})
					}
				});
			}
        }

    }
</script>
<style scoped>
    * {
        list-style: none;
        text-decoration: none;
    }

    .paper_main {
        width: 100%;

    }

    .paper_main .ks_left {
        float: left;
    }

    .paper_main .ks_left .test {
        border: 1px solid #E4E4E4;
    }


    .ks_coon_tp img {
        width: 20px;
        height: 20px;
        display: inline-block;
        line-height: 47px;
        padding: 2px 0 0 2px;
        position: absolute;
        top: 12px;
    }

    .ks_coon_tp p {
        font-size: 16px;
        font-family: 微软雅黑;
        display: inline-block;
        line-height: 47px;
        color: rgb(72, 138, 124);
        margin-left: 25px;
    }

    .test_sj h2 {
        padding-top: 10px;
        padding-bottom: 5px;
    }

    .test_sj p {
        padding-bottom: 5px;
    }

    .ks_coon_bt {
        width: 95%;
        margin: 0 auto;
        height: 35px;
        background-color: #E4E4E4;
        margin-top: 15px;
    }

    .ks_coon_bt p {
        padding-left: 18px;
        line-height: 35px;
        color: darkslateblue;
    }

    .ks_coon_date {
        width: 95%;
        margin: 0 auto;
        margin-top: 10px;
        border: 1px solid #E4E4E4;
        margin-bottom: 10px;
    }

    .ks_coon_date .ks_coon_dates {
        padding: 10px 0 0 5px;
        color: #666;;
    }

    label, td {
        color: #666;
    }

    /*右边答题卡*/
    .paper_main .ks_right {
        position: fixed;
        right: 20px;
        width: 268px;
    }

    .ks_coons_dt h3 {
        height: 45px;
        text-align: center;
        margin: 0 auto;
        display: block;
        color: #fff;
        line-height: 45px;
    }


    .ks_coons-s h3 {
        width: 150px;
        font-size: 14px;
        line-height: 40px;
    }

    .ks_coons-xs ul {
        padding: 2px;
        text-align: left;
    }

    .ks_coons-xs ul li {
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        margin-bottom: 5px;
        display: inline-block;
        border: 1px solid #E4E4E4;
        margin-left: 5px;
    }

    .ks_coons-xs ul li a {
        display: block;
    }

    a {
        text-decoration: none;
        color: #666666;
    }


    .ks_coons-xh .tz {
        line-height: 30px;
        text-align: center;
        display: block;
        color: white;
        cursor: pointer
    }

    .ks_coon_date table tbody tr td h6 span {
        display: inline-block;
        vertical-align: top;
        color: #FFFFFF;
        background-color: #2EB3E5;
        width: 24px;
        height: 24px;
        margin-right: 5px;
        text-align: center;
        line-height: 24px;
        margin-left: 12px;
        margin-top: 7px;
        border-radius: 12%;
    }

	.ks_coon_date table tbody tr td h6 p.ys {
		display: inline-block;
		vertical-align: top;
		/*color: black;*/
		/*background-color: #d1f3e5;*/
		width: 24px;
		height: 24px;
		margin-right: 5px;
		text-align: center;
		line-height: 24px;
		margin-left: 12px;
		margin-top: 7px;
		border-radius: 50%;
		font-size: 15px;
	}

    label {
        font-weight: 400;
    }

    .optTbl .td1 {
        width: 55px;
        text-align: right;

    }

    .optTbl td {
        margin: 0px;
        padding: 4px 0px !important;
    }

    .ks_coon_date td {
        vertical-align: top;

    }

    .ks_coon_date tr td p {
        vertical-align: top;
        color: #666666;
    }

    .scoreTable {
        border-collapse: collapse;
        border-spacing: 10px 50px;
        margin: 10px auto;
        width: 90%;
    }

    .scoreTable td {
        border: 1px solid #000;
        padding: 5px;
        height: 22px;
        text-align: center;
        font-size: 14px;
        font-family: '宋体';
    }
</style>
